import { withInstall } from '@lit-element/utils'

import Scrollbar from './src/scrollbar.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtScrollbar: SFCWithInstall<typeof Scrollbar> =
  withInstall(Scrollbar)
export default LtScrollbar

export * from './src/util'
export * from './src/scrollbar'
export * from './src/thumb'
export * from './src/constants'
